export default "__VITE_ASSET__BRrEOj85__"